import { CommandelineEntity } from '../../../graphql/generated/graphql';
import { sanitizeCalul } from '../../number/sanitizeCalul';
import { CommandeLinePanier } from '../../../types/commandeLine/commandeLine.def';
import { getProductOnPanierFromQuery } from '../product';

export const getCommandeLinePanierFromQuery: (
  cml: Partial<CommandelineEntity>
) => CommandeLinePanier = cml => ({
  id: cml.id,
  produit: getProductOnPanierFromQuery(cml.attributes?.produit?.data),
  quantite: cml.attributes?.quantite,
  totalLine: sanitizeCalul(
    cml.attributes?.produit?.data?.attributes?.ttcPrice *
      cml.attributes?.quantite
  )
});
